import { render } from "./FileDemo.vue?vue&type=template&id=18f22a23"
import script from "./FileDemo.vue?vue&type=script&lang=js"
export * from "./FileDemo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__